import { useSelector } from 'react-redux';
import isIframe from '../../utils/iframe-utils.js';
import { selectShowNewCookieBanner, selectIsBotRequest } from '../brand/ducks/selectors';
import useConfiguration from '~/configuration/use-configuration';
import { Suspense, lazy, useMemo } from 'react';
import { isCookieConsentTrue } from '~/store/cookies';

const CookieNotification = lazy(() => import('../cookie-notification.js'));

const CookieBanner = lazy(() => import('./cookie-banner.js'));

// One cookie banner component that switches between two
const CookieBannerContainer = ({ children }) => {
	const showNewCookieBanner = useSelector(selectShowNewCookieBanner);
	const { disableCookieBanner } = useConfiguration();
	const iframe = useMemo(() => {
		return isIframe();
	}, []);
	const cookieConsent = useMemo(() => {
		return isCookieConsentTrue();
	}, []);
	const isBotRequest = useSelector(selectIsBotRequest);

	if (!showNewCookieBanner && !iframe && !disableCookieBanner && !cookieConsent && !isBotRequest) {
		return (
			<Suspense fallback={<div />}>
				<CookieNotification />
				{children}
			</Suspense>
		);
	}

	return <CookieBanner showNewCookieBanner={showNewCookieBanner}>{children}</CookieBanner>;
};

export default CookieBannerContainer;
